import { withInstall } from '../utils';
import _Popup from './Popup';
export var Popup = withInstall(_Popup);
export default Popup;